import { useState, useCallback, useEffect } from 'react';

import useSetStateImmutable from '@/hooks/useSetStateImmutable';

const useProperty = (
    model,
    get,
    { boundEvents, getArg, initialState = null } = {}
) => {
    const [state, setState] = useState(initialState);

    const setStateImmutable = useSetStateImmutable(setState);
    const updateState = useCallback(() => {
        setStateImmutable(Mobi2Go[model][get](getArg));
    }, [setStateImmutable, model, get, getArg]);

    useEffect(() => {
        (boundEvents ?? []).forEach(e => {
            Mobi2Go[model].bind(e, updateState);
        });

        return () => {
            (boundEvents ?? []).forEach(e => {
                Mobi2Go[model].unbind(e, updateState);
            });
        };
    }, [model, boundEvents, updateState]);

    useEffect(() => {
        if (Mobi2Go[model].onReady) {
            Mobi2Go[model].onReady(updateState);
        } else {
            updateState();
        }
    }, [model, updateState]);

    return state;
};

export default useProperty;
